let body = document.querySelector("body");

// HEADER MENU
const btnBurger = document.querySelector(".header_burger");
const headerMenu = document.querySelector(".header_menu");
btnBurger.addEventListener("click", () => {
  headerMenu.classList.toggle("active");
  document.querySelector("body").classList.toggle("lock");
});
const closeHeaderMenu = document.querySelector(".close_burger-menu");
closeHeaderMenu.addEventListener("click", () => {
  headerMenu.classList.remove("active");
  document.querySelector("body").classList.remove("lock");
});

// END HEADER MENU

//  MAIN SLIDER BLOCK WITH SLIDER
const mainSlider = document.querySelector(".main-slider");
if (mainSlider) {
  // SWIPER SLIDER
  const swiper = new Swiper('.swiper', {
    slidesPerView: 1,
    loop: true,
    speed: 700,
    autoplay: {
      delay: 6000
    },
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  });
}
//  END MAIN SLIDER BLOCK WITH SLIDER

// MODAL VIDEO
const modalVideo = document.querySelector("#modal_video");
const wrapperPage = document.querySelector(".wrapper_page");
const closeModalVideo = document.querySelector(".btn_close_modal_video");
const blockModalVideo = document.querySelector(".block_modal_video");
// const containerBlock1 = document.querySelector(".container_block1");

// open modal video
// containerBlock1.addEventListener("click", event => {
//   let elClick = event.target.closest(".btn_modal_video");
//   if (elClick) {
//     addVideoModal();
//     modalVideo.style.display = "block";
//     wrapperPage.classList.add("blur");
//     document.querySelector("body").classList.add("lock");
//   }
// });

// add video block to modal
function addVideoModal() {
  const containerVideo = document.createElement("div");
  containerVideo.classList.add("container_video");
  containerVideo.innerHTML = `
	<iframe src="` + videoURL + `" frameborder="0"
		allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="">
	</iframe>
	`;
  blockModalVideo.appendChild(containerVideo);
}

// remove video block from modal
function removeVideoModal() {
  blockModalVideo.removeChild(document.querySelector(".container_video"));
}

// close modal video
closeModalVideo.addEventListener("click", () => {
  removeVideoModal();
  modalVideo.style.display = "none";
  wrapperPage.classList.remove("blur");
  document.querySelector("body").classList.remove("lock");
});
window.addEventListener("click", event => {
  if (event.target == modalVideo) {
    removeVideoModal();
    modalVideo.style.display = "none";
    wrapperPage.classList.remove("blur");
    document.querySelector("body").classList.remove("lock");
  }
});
// END MODAL VIDEO

// MODAL AIRPORT
const modalAirport = document.querySelector("#modal_airport");
const openModalAirport = document.querySelector("#btn_open_modal_airport");
const closeModalAirport = document.querySelector(".btn_close_modal_airport");

// open modal airport
body.addEventListener("click", event => {
  let elClick = event.target.closest(".btn_open_modal_airport");
  if (elClick) {
    modalAirport.style.display = "block";
    wrapperPage.classList.add("blur");
    document.querySelector("body").classList.add("lock");
  }
});
// openModalAirport.addEventListener("click", () => {
// 	modalAirport.style.display = "block";
// 	wrapperPage.classList.add("blur");
// 	document.querySelector("body").classList.add("lock");
// });

// close modal airport
closeModalAirport.addEventListener("click", () => {
  modalAirport.style.display = "none";
  wrapperPage.classList.remove("blur");
  document.querySelector("body").classList.remove("lock");
});
window.addEventListener("click", event => {
  if (event.target == modalAirport) {
    modalAirport.style.display = "none";
    wrapperPage.classList.remove("blur");
    document.querySelector("body").classList.remove("lock");
  }
});

// END MODAL AIRPORT

// BLOCK2 TABS
const containerBlock2 = document.querySelector(".container_block2");
const tabsItem = document.querySelectorAll(".block2_item");
const tabsContent = document.querySelectorAll(".container_block2_tab");
const closeBlock2Tab = document.querySelector(".close_block2_tab");

// close tabs in block2
closeBlock2Tab.addEventListener("click", () => {
  removeClasses(tabsItem, "active");
  removeClasses(tabsContent, "active");
  document.querySelector("body").classList.remove("lock");
  closeBlock2Tab.classList.remove("show");
  containerBlock2.querySelector(".btn_main.red").classList.remove("hide");
  // scrollToElement(containerBlock2);
});
if (containerBlock2) {
  document.addEventListener('mousedown', function (e) {
    if (e.target.closest('.blocks_method_content') === null) {
      removeClasses(tabsItem, "active");
      removeClasses(tabsContent, "active");
      if (e.target.closest('.container_block3') !== null || e.target.closest('.container_block2')) {
        document.querySelector("body").classList.remove("lock");
      }
      // closeBlock2Tab.classList.remove("show");
    }
  });
}

// open tabs in block2
containerBlock2.addEventListener("click", event => {
  let elClick = event.target.closest(".block2_item");
  if (elClick) {
    if (elClick.querySelector(".go-to-method") === null) {
      let dataTabItem = elClick.getAttribute("data-tab-item");
      for (let tabContent of tabsContent) {
        let dataTabContent = tabContent.getAttribute("data-tab-content");
        if (dataTabItem == dataTabContent) {
          // containerBlock2.querySelector(".btn_main.red").classList.remove("hide");
          // if (dataTabItem === "examination_group") {
          //   containerBlock2.querySelector(".btn_main.red").classList.add("hide");
          // }
          document.querySelector("body").classList.add("lock");
          removeClasses(tabsItem, "active");
          removeClasses(tabsContent, "active");
          elClick.classList.add("active");
          tabContent.classList.add("active");
        }
      }
    } else {
      openMethodContent(elClick.querySelector(".go-to-method"));
    }
  }
});
// END BLOCK2 TABS

// remove class in element from array of elements
function removeClasses(arr, className) {
  for (let el of arr) {
    el.classList.remove(className);
  }
}
// add class in element from array of elements
function addClasses(arr, className) {
  for (let el of arr) {
    el.classList.add(className);
  }
}

// scrolling page to element
function scrollToElement(el) {
  const yOffset = -170;
  const scrollPossition = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
  window.scrollTo({
    top: scrollPossition,
    behavior: "smooth"
  });
}

// BLOCK3 METHODS CONTENT
// tabs research desktop
const wrapperBlock3 = document.querySelector(".container_block3");
const tabsResearch = document.querySelectorAll(".item_tab_methods");

// show/hide last close btn in method block
function showHideCloseBtn(elem, condition) {
  let btnsClose = elem.closest(".container_block3_methods_content").querySelectorAll(".close_method_content");
  if (condition === "remove") {
    btnsClose[btnsClose.length - 1].classList.remove("active");
  }
  if (condition === "add") {
    btnsClose[btnsClose.length - 1].classList.add("active");
  }
}

// close tab for desktop in block3
wrapperBlock3.addEventListener("click", event => {
  let elClick = event.target.closest(".close_block3_tab");
  if (elClick) {
    void 0;
    const wrapperBlock3Content = elClick.closest(".method_content_desktop").querySelectorAll(".wrapper_block3_content");
    showHideCloseBtn(elClick, "remove");
    document.querySelector("body").classList.remove("lock");
    removeClasses(tabsResearch, "active");
    removeClasses(wrapperBlock3Content, "active");
    elClick.classList.remove("show");
    scrollToElement(elClick.closest(".method_content_desktop"));
  }
});

// open tab for desktop in block3
wrapperBlock3.addEventListener("click", event => {
  let elClick = event.target.closest(".item_tab_methods");
  if (elClick) {
    let dataTabItem = elClick.getAttribute("data-tab-research");
    const wrapperBlock3Content = elClick.closest(".method_content_desktop").querySelectorAll(".wrapper_block3_content");
    for (let tabContent of wrapperBlock3Content) {
      let dataTabContent = tabContent.getAttribute("data-content-research");
      if (dataTabItem == dataTabContent) {
        showHideCloseBtn(tabContent, "add");
        document.querySelector("body").classList.add("lock");
        removeClasses(tabsResearch, "active");
        removeClasses(wrapperBlock3Content, "active");
        elClick.classList.add("active");
        tabContent.classList.add("active");
        const closeBlock3Tab = elClick.closest(".method_content_desktop").querySelector(".close_block3_tab");
        closeBlock3Tab.classList.add("show");
        scrollToElement(tabContent);
      }
    }
  }
});
// end tabs research desktop

// tabs research mobile
const tabsResearchMob = document.querySelectorAll(".item_tab_methods_mob");

// close tab for mobile in block3
wrapperBlock3.addEventListener("click", event => {
  let elClick = event.target.closest(".close_block3_tab_mobile");
  if (elClick) {
    const wrapperBlock3Content = elClick.closest(".method_content_mobile").querySelectorAll(".wrapper_block3_content_mob");
    removeClasses(tabsResearchMob, "active");
    removeClasses(wrapperBlock3Content, "active");
    showHideCloseBtn(elClick, "remove");
    elClick.classList.remove("show");
    scrollToElement(elClick.closest(".method_content_mobile"));
  }
});

// open tab for mobile in block3
wrapperBlock3.addEventListener("click", event => {
  let elClick = event.target.closest(".item_tab_methods_mob");
  if (elClick) {
    let dataTabItem = elClick.getAttribute("data-tab-research");
    const wrapperBlock3Content = elClick.closest(".method_content_mobile").querySelectorAll(".wrapper_block3_content_mob");
    for (let tabContent of wrapperBlock3Content) {
      let dataTabContent = tabContent.getAttribute("data-content-research");
      if (dataTabItem == dataTabContent) {
        removeClasses(tabsResearch, "active");
        removeClasses(wrapperBlock3Content, "active");
        showHideCloseBtn(tabContent, "add");
        elClick.classList.add("active");
        tabContent.classList.add("active");
        const closeBlock3Tab = elClick.closest(".method_content_mobile").querySelector(".close_block3_tab_mobile");
        closeBlock3Tab.classList.add("show");
        scrollToElement(tabContent);
      }
    }
  }
});
// end tabs research mobile

const containerBlock3 = document.querySelector(".container_block3");
const methodContentsDesktop = document.querySelectorAll(".method_content_desktop");
const methodContentsMobile = document.querySelectorAll(".method_content_mobile");
const methodBtns = containerBlock3.querySelectorAll(".btn_method");

// open method content
containerBlock3.addEventListener("click", event => {
  let elClick = event.target.closest(".btn_method");
  if (elClick) {
    openMethodContent(elClick);
    document.querySelector("body").classList.add("lock");
  }
});

// open method content
function openMethodContent(elClick) {
  let dataMethodBtn = elClick.getAttribute("data-method-btn");
  const withDisplay = window.matchMedia("(max-width: 900px)");
  if (withDisplay.matches) {
    for (let content of methodContentsMobile) {
      let dataMethodContent = content.getAttribute("data-method-content");
      if (dataMethodBtn == dataMethodContent) {
        removeClasses(methodContentsMobile, "active");
        addClasses(methodBtns, "active");
        elClick.classList.remove("active");
        if (content.querySelector(".block_tab_methods")) {
          showHideCloseBtn(content, "remove");
        }
        content.classList.add("active");
        // scrollToElement(content);
      }
    }
  } else {
    for (let content of methodContentsDesktop) {
      let dataMethodContent = content.getAttribute("data-method-content");
      if (dataMethodBtn == dataMethodContent) {
        if (content.querySelector(".block_tab_methods")) {
          showHideCloseBtn(content, "remove");
        }
        removeClasses(methodContentsDesktop, "active");
        removeClasses(methodBtns, "active");
        content.classList.add("active");
        document.querySelector("body").classList.add("lock");

        // scrollToElement(content);
      }
    }
  }
}
// close method content
containerBlock3.addEventListener("click", event => {
  let elClick = event.target.closest(".block_close_popup");
  if (elClick) {
    removeClasses(methodContentsDesktop, "active");
    removeClasses(methodContentsMobile, "active");
    addClasses(methodBtns, "active");
    closeAllTabsMethods();
    document.querySelector("body").classList.remove("lock");
    let dataMethodContent = elClick.closest(".container_block3_methods_content").getAttribute("data-method-content");
    for (let btn of methodBtns) {
      let dataMethodBtn = btn.getAttribute("data-method-btn");
      if (dataMethodContent == dataMethodBtn) {
        scrollToElement(btn.closest(".item_block3_method"));
      }
    }
  }
});

// close method content click on el .btn_scroll_to
containerBlock3.addEventListener("click", event => {
  let elClick = event.target.closest(".btn_scroll_to");
  if (elClick) {
    removeClasses(methodContentsDesktop, "active");
    removeClasses(methodContentsMobile, "active");
    addClasses(methodBtns, "active");
    closeAllTabsMethods();
    document.querySelector("body").classList.remove("lock");
    let dataMethodContent = elClick.closest(".container_block3_methods_content").getAttribute("data-method-content");
    for (let btn of methodBtns) {
      let dataMethodBtn = btn.getAttribute("data-method-btn");
      if (dataMethodContent == dataMethodBtn) {
        scrollToElement(btn.closest(".item_block3_method"));
      }
    }
  }
});
body.addEventListener('mousedown', function (e) {
  if (e.target.closest('.blocks_method_content') === null) {
    removeClasses(methodContentsDesktop, "active");
    removeClasses(methodContentsMobile, "active");
    addClasses(methodBtns, "active");
    closeAllTabsMethods();
    // document.querySelector("body").classList.remove("lock");
  }
});
function closeAllTabsMethods() {
  removeClasses(document.querySelectorAll(".item_tab_methods"), "active");
  removeClasses(document.querySelectorAll(".wrapper_block3_content"), "active");
  removeClasses(document.querySelectorAll(".close_block3_tab"), "show");
  removeClasses(document.querySelectorAll(".item_tab_methods_mob"), "active");
  removeClasses(document.querySelectorAll(".wrapper_block3_content_mob"), "active");
  removeClasses(document.querySelectorAll(".close_block3_tab_mobile"), "show");
}

// CHECK ANCHOR IN OUTSIDE URL AND OPEN METHOD PLR
if (window.location.hash == "#method-plr") {
  openMethodContent(document.querySelector('[data-method-btn="diagnostic_methods_plr"]'));
}
// END BLOCK3 METHODS CONTENT

// BLOCK4 OPEN TABLE
const containerBlock4 = document.querySelector(".container_block4_table-mobile");
// toggle answer blocks
containerBlock4.addEventListener("click", event => {
  let elClick = event.target.closest(".table-mobile_question_item");
  if (elClick) {
    elClick.classList.toggle("open-item");
    elClick.nextElementSibling.classList.toggle("open");
  }
});
// END BLOCK4 OPEN TABLE

// BLOCK5 BLOCK6 POPUP
const containerBlock6 = document.querySelector(".container_block6");
const containerPopups = document.querySelectorAll(".container_popup");
const containerBlock5 = document.querySelector(".container_block5");

// open pop up in block5
containerBlock5.addEventListener("click", event => {
  let elClick = event.target.closest(".btn_method");
  // document.querySelector("body").classList.remove("lock");
  if (elClick) {
    void 0;
    let popup = elClick.closest(".item_method_res").querySelector(".container_popup");
    if (popup) {
      removeClasses(containerPopups, "active");
      popup.classList.add("active");
      document.querySelector("body").classList.add("lock");
    }
  }
});

// open pop up in block6
containerBlock6.addEventListener("click", event => {
  let elClick = event.target.closest(".block6_btn_popup");
  document.querySelector("body").classList.remove("lock");
  if (elClick) {
    let popup = elClick.querySelector(".container_popup");
    if (popup) {
      removeClasses(containerPopups, "active");
      popup.classList.add("active");
      document.querySelector("body").classList.add("lock");
    }
  }
});
// close pop up
body.addEventListener("click", event => {
  let elClick = event.target.closest(".block6_close_popup");
  if (elClick) {
    removeClasses(containerPopups, "active");
    elClick.closest(".container_popup").classList.remove("active");
    document.querySelector("body").classList.remove("lock");
  }
});
containerBlock5.addEventListener('mousedown', function (e) {
  if (e.target.closest('.container_popup-box') === null) {
    removeClasses(containerPopups, "active");
    try {
      elClick.closest(".container_popup").classList.remove("active");
    } catch (e) {
      void 0;
    }
    document.querySelector("body").classList.remove("lock");
  }
});
containerBlock6.addEventListener('mousedown', function (e) {
  if (e.target.closest('.container_popup-box') === null) {
    removeClasses(containerPopups, "active");
    document.querySelector("body").classList.remove("lock");
    try {
      elClick.closest(".container_popup").classList.remove("active");
    } catch (e) {
      void 0;
    }
  }
});
// END BLOCK5 BLOCK6 POPUP

// BLOCK8 TABS
const containerBlock8 = document.querySelector(".container_block8");
const tabsItemBlock8 = document.querySelectorAll(".block8_item_icon");
const tabsContentBlock8 = document.querySelectorAll(".block8_content");

// open tab in block8
containerBlock8.addEventListener("click", event => {
  let elClick = event.target.closest(".block8_item_icon");
  if (elClick) {
    let dataTabItem = elClick.getAttribute("data-tab-item");
    for (let tabContent of tabsContentBlock8) {
      let dataTabContent = tabContent.getAttribute("data-tab-content");
      if (dataTabItem == dataTabContent) {
        removeClasses(tabsItemBlock8, "active");
        removeClasses(tabsContentBlock8, "active");
        elClick.classList.add("active");
        tabContent.classList.add("active");
        // start carousel
        // clearInterval(timerCarousel);
        // setTimeout(() => {
        //   startCarouselInterval();
        // }, 10000);
      }
    }
  }
});

// switch tabs and content
function carouselTabs() {
  let tabs = document.querySelectorAll(".block8_item_icon");
  let contents = document.querySelectorAll(".block8_content");
  for (let i = 0; i < tabs.length; i++) {
    if (tabs[i].classList.contains("active")) {
      let nextIndex;
      if (tabs[i + 1] !== undefined) {
        nextIndex = i + 1;
      } else {
        nextIndex = 0;
      }
      let tabItem = tabs[nextIndex].getAttribute("data-tab-item");
      for (let content of contents) {
        let contentItem = content.getAttribute("data-tab-content");
        if (tabItem == contentItem) {
          removeClasses(tabs, "active");
          removeClasses(contents, "active");
          tabs[nextIndex].classList.add("active");
          content.classList.add("active");
        }
      }
      break;
    }
  }
}
// timer
let timerCarousel;

// startCarouselInterval();
// start interval carousel
function startCarouselInterval() {
  timerCarousel = setInterval(() => {
    carouselTabs();
  }, 5000);
}
// END BLOCK8 TABS

// BLOCK9 OPEN ANSWER
const containerBlock9 = document.querySelector(".container_block9");
// toggle answer blocks
containerBlock9.addEventListener("click", event => {
  let elClick = event.target.closest(".block9_question_item");
  if (elClick) {
    elClick.classList.toggle("open-item");
    elClick.querySelector(".arrow").classList.toggle("open");
    elClick.nextElementSibling.classList.toggle("open");
  }
  // show block with FAQ
  let block9Questions = document.querySelector(".block9_questions");
  let readMore = event.target.closest("._js-block_main_title");
  if (readMore) {
    block9Questions.classList.toggle("open");
    readMore.classList.toggle("_js-block_main_title--active");
  }
});
// END BLOCK9 OPEN ANSWER

// CHECK ANCHOR IN OUTSIDE URL AND SCROLL
if (window.location.hash == "#examine" || window.location.hash == "#rules" || window.location.hash == "#home") {
  setTimeout(() => {
    let hash = window.location.hash.substring(1);
    void 0;
    let elByHash = document.querySelector("#" + hash);
    void 0;
    let yOffset = -100;
    if (window.location.hash == "#home") {
      if (window.matchMedia("(min-width: 1500px)").matches) {
        yOffset = -190;
      } else if (window.matchMedia("(min-width: 768px)").matches) {
        yOffset = -120;
      }
    }
    const scrollPossition = elByHash.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({
      top: scrollPossition
    });
  }, 50);
}
// HEADER SCROLL TO CONTENT
const blocksContent = document.querySelectorAll(".container_wrapper_block");

// scroll to element
body.addEventListener("click", event => {
  let elClick = event.target.closest(".header_nav_item");
  if (elClick) {
    let navId = elClick.getAttribute("data-nav-id");
    for (let content of blocksContent) {
      let blockId = content.getAttribute("data-block-id");
      if (navId == blockId) {
        const yOffset = -100;
        const scrollPossition = content.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({
          top: scrollPossition,
          behavior: "smooth"
        });
        btnBurger.classList.remove("active");
        headerMenu.classList.remove("active");
        document.querySelector("body").classList.remove("lock");
      }
    }
  }
});
// END HEADER SCROLL TO CONTENT

// SCROLL TO CONTENT
const blocksScrollTo = document.querySelectorAll(".block_scroll_to");
body.addEventListener("click", event => {
  let elClick = event.target.closest(".btn_scroll_to");
  if (elClick) {
    let navId = elClick.getAttribute("data-btn-scroll");
    for (let content of blocksScrollTo) {
      let blockId = content.getAttribute("data-block-scroll");
      if (navId == blockId) {
        const yOffset = -150;
        const scrollPossition = content.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({
          top: scrollPossition,
          behavior: "smooth"
        });
      }
    }
  }
});
// END SCROLL TO CONTENT

// function for close modal when click btn close
function closeModalBtn(modal, btnClose) {
  btnClose.addEventListener("click", () => {
    modal.style.display = "none";
    wrapperPage.classList.remove("blur");
    document.querySelector("body").classList.remove("lock");
  });
}
// function for close modal when click outside modal
function closeModal(modal) {
  window.addEventListener("click", event => {
    if (event.target == modal) {
      modal.style.display = "none";
      wrapperPage.classList.remove("blur");
      document.querySelector("body").classList.remove("lock");
    }
  });
}

// get data-value from research select
function selectionResearch() {
  let researchValues = getResearchValue();
  setNullSelect(".wrapper_lab");
  document.querySelector(".wrapper_research_cost").innerHTML = document.querySelector(".wrapper_research_cost").getAttribute("data-placeholder");
  requestGetLabs(researchValues);
}

// get data-value attribure from selected options in research select
function getResearchValue() {
  let researchValues = [];
  const selectedOptions = document.querySelectorAll(".wrapper_research .custom-option.selected");
  for (let option of selectedOptions) {
    researchValues.push(option.getAttribute("data-value"));
  }
  return researchValues;
}

// set options in select
function setSelectOptions(arrOptions, classBlockOptions) {
  if (arrOptions != null) {
    let wrapperOption = document.querySelector(classBlockOptions + " .wrraper-custom-options");
    wrapperOption.innerHTML = "";
    for (let option of arrOptions) {
      let elOption = document.createElement("span");
      elOption.classList.add("custom-option");
      elOption.setAttribute("data-value", option.value);
      if (classBlockOptions === ".wrapper_research") {
        elOption.innerHTML = option.text + `<div class="block_close"><img src="` + closeImgSrc + `" alt=""></div>`;
      } else {
        elOption.innerHTML = option.text;
      }
      wrapperOption.appendChild(elOption);
    }
  }
}

// request get labs
function requestGetLabs(researchValues) {
  const url = document.querySelector(".wrapper_research").getAttribute("data-url");
  const request = new XMLHttpRequest();
  const params = "&research=" + researchValues + "&locality_id=" + document.querySelector(".js-landing-covid .selected").getAttribute("data-value") + "&_csrf=" + csrfToken;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4 && request.status === 200) {
      let response = JSON.parse(request.responseText);
      // console.log("response", response);
      let arrLabs = convertResponse(response.labs);
      setSelectOptions(arrLabs, ".wrapper_lab");
    }
  });
  request.send(params);
}
function convertResponse(response) {
  let tmpArray = [];
  for (const [key, value] of Object.entries(response)) {
    tmpArray.push({
      text: value,
      value: key
    });
  }
  return tmpArray;
}

// MODAL IN DEPARTMENT

let modalDepartment = document.querySelector(".department_for_plr");
let modalDepartmentAg = document.querySelector(".department_for_ag");

// open modal department
function openModalDepartmentPLR() {
  void 0;
  removeModalResult(".department_for_ag .block_department_result");
  removeModalResult(".department_for_plr .block_department_result");
  setNullSelect(".department_for_plr .wrapper_department");
  modalDepartment.style.display = "block";
  wrapperPage.classList.add("blur");
  document.querySelector("body").classList.add("lock");
  checkCityDepartment("department_for_plr");
}
function checkCityDepartment(typeModal) {
  let currentUserCity = document.querySelector(".js-landing-covid .selected").getAttribute("data-value");
  let cityIDs = [];
  let arrCityEl = document.querySelectorAll(`.${typeModal} .custom-option`);
  for (let cityEl of arrCityEl) {
    cityIDs.push(cityEl.getAttribute("data-value"));
  }
  let checkCity = cityIDs.find(item => item == currentUserCity);
  if (checkCity === undefined) {
    document.querySelector(`.${typeModal} .select-city-popup-info`).classList.add("show");
  } else {
    document.querySelector(`.${typeModal} .select-city-popup-info`).classList.remove("show");
    selectCityByEl(arrCityEl, currentUserCity);
  }
}
function selectCityByEl(arrEl, currentUserCity) {
  for (let el of arrEl) {
    if (el.getAttribute("data-value") == currentUserCity) {
      el.click();
      break;
    }
  }
}
body.addEventListener("click", event => {
  let elClick = event.target.closest(".open_modal_department");
  if (elClick) {
    openModalDepartmentPLR();
  }
});
// CHECK ANCHOR IN OUTSIDE URL AND OPEN MODAL DEPARTMENT PLR
if (window.location.hash == "#department-plr-modal") {
  setTimeout(() => {
    document.querySelector(".open_modal_department").click();
    // openModalDepartmentPLR();
  }, 50);
}

// CHECK ANCHOR IN OUTSIDE URL AND OPEN MODAL DEPARTMENT AG
if (window.location.hash == "#department_modal_for_ag") {
  setTimeout(() => {
    document.querySelector(".open_modal_department_ag").click();
    // openModalDepartmentAg();
  }, 50);
}

// open modal department ag
body.addEventListener("click", event => {
  let elClick = event.target.closest(".open_modal_department_ag");
  if (elClick) {
    openModalDepartmentAg();
  }
});
function openModalDepartmentAg() {
  removeModalResult(".department_for_ag .block_department_result");
  removeModalResult(".department_for_plr .block_department_result");
  setNullSelect(".department_for_ag .wrapper_department");
  modalDepartmentAg.style.display = "block";
  wrapperPage.classList.add("blur");
  document.querySelector("body").classList.add("lock");
  checkCityDepartment("department_for_ag");
}

// close modal department/modal department AG
body.addEventListener("click", event => {
  let elClick = event.target.closest(".close_modal_department");
  if (elClick) {
    let modalsDepartment = document.querySelectorAll(".modal_department");
    for (let modal of modalsDepartment) {
      modal.style.display = "none";
    }
    wrapperPage.classList.remove("blur");
    document.querySelector("body").classList.remove("lock");
  }
});
closeModal(modalDepartment);
closeModal(modalDepartmentAg);
// END MODAL IN DEPARTMENT

// MODAL IN HOME

let modalHome = document.querySelector("#modal_home");
let closeModalHome = document.querySelector(".close_modal_home");

// open modal home
function openModalHome() {
  removeModalResult(".block_home_result");
  setNullSelect(".wrapper_home");
  modalHome.style.display = "block";
  wrapperPage.classList.add("blur");
  document.querySelector("body").classList.add("lock");
}
;
body.addEventListener("click", event => {
  let elClick = event.target.closest(".open_modal_home");
  if (elClick) {
    openModalHome();
  }
});
// CHECK ANCHOR IN OUTSIDE URL AND OPEN MODAL HOME
if (window.location.hash == "#home-modal") {
  setTimeout(() => {
    openModalHome();
  }, 50);
}
// close modal home
closeModalBtn(modalHome, closeModalHome);
closeModal(modalHome);
// END MODAL IN HOME

// CUSTOM SELECT
// toggle block with options custom select
for (const dropdown of document.querySelectorAll(".custom-select-wrapper")) {
  dropdown.addEventListener("click", function (event) {
    // check multiselect
    // if (this.closest(".wrapper_research") !== null) {
    //   if (event.target.closest(".custom-options") === null) {
    //     // this.querySelector('.custom-select').classList.toggle('open');
    //     if (this.querySelector(".custom-select").classList.contains("open")) {
    //       this.querySelector(".custom-select").classList.remove("open");
    //       console.log("research request11");

    //       // set selected research option
    //       researchsToBlockSelected();
    //       selectionResearch("research");
    //     } else {
    //       this.querySelector(".custom-select").classList.add("open");
    //     }
    //   }
    // } else {
    //   this.querySelector(".custom-select").classList.toggle("open");
    // }

    if (this.closest(".wrapper_research") !== null) {
      // if city don't selected - show modal with city select
      if (selectedCityCheck()) {
        modalChangeCity.style.display = "block";
      } else {
        this.querySelector(".custom-select").classList.toggle("open");
      }
    } else if (this.closest(".wrapper_lab") !== null) {
      // check options in lab select
      if (this.closest(".wrapper_lab").querySelectorAll(".custom-option").length != 0) {
        this.querySelector(".custom-select").classList.toggle("open");
      }
    } else {
      this.querySelector(".custom-select").classList.toggle("open");
    }
  });
}

// select/unselect option in selects
body.addEventListener("click", function (event) {
  let elClick = event.target.closest(".custom-option");
  if (elClick) {
    // for multiselect
    if (elClick.closest(".wrapper_research") !== null) {
      if (elClick.classList.contains("selected")) {
        elClick.classList.remove("selected");
        elClick.closest(".custom-select").querySelector(".custom-select__trigger span").textContent = countSelectedOptions(elClick.closest(".wrapper_research"));
      } else {
        elClick.classList.add("selected");
        elClick.closest(".custom-select").querySelector(".custom-select__trigger span").textContent = countSelectedOptions(elClick.closest(".wrapper_research"));
      }
      checkSelect(elClick);
    }
    // for single select
    else {
      if (!elClick.classList.contains("selected")) {
        if (elClick.parentNode.querySelector(".custom-option.selected") !== null) {
          elClick.parentNode.querySelector(".custom-option.selected").classList.remove("selected");
        }
        elClick.classList.add("selected");
        elClick.closest(".custom-select").querySelector(".custom-select__trigger span").textContent = elClick.textContent;
        let dataValue = elClick.getAttribute("data-value");
        elClick.closest(".custom-select").querySelector(".custom-select__trigger span").setAttribute("data-value", dataValue);

        // set data-locality-id for select city
        let dataLocalityId = elClick.getAttribute("data-locality-id");
        if (dataLocalityId !== null) {
          elClick.closest(".custom-select").querySelector(".custom-select__trigger span").setAttribute("data-locality-id", dataLocalityId);
        }
        checkSelect(elClick);
      }
    }
  }
});

// close select when click outside current select
window.addEventListener("click", function (e) {
  for (const select of document.querySelectorAll(".custom-select")) {
    if (!select.contains(e.target)) {
      // check close select research and send request
      if (select.closest(".wrapper_research") !== null && select.classList.contains("open")) {
        selectionResearch();
      }
      select.classList.remove("open");
    }
  }
});

// count selected options in select and return
function countSelectedOptions(select) {
  let count = select.querySelectorAll(".custom-option.selected").length;
  if (count > 0) {
    return select.getAttribute("data-text-count1") + " " + count + " " + select.getAttribute("data-text-count2");
  } else {
    return select.getAttribute("data-select-placeholder");
  }
}
// check select that use and call function
function checkSelect(select) {
  let dataUrl;
  let dataValue = select.getAttribute("data-value");
  void 0;
  void 0;
  if (select.closest(".wrapper_home")) {
    dataUrl = select.closest(".wrapper_home").getAttribute("data-url");
    requestResultModal(dataUrl, dataValue, "home");
  } else if (select.closest(".wrapper_department")) {
    dataUrl = select.closest(".wrapper_department").getAttribute("data-url");
    let dataDepartmentType = select.closest(".wrapper_department").getAttribute("data-research-type");

    // check data-research-type
    if (dataDepartmentType === "plr") {
      requestResultModal(dataUrl, dataValue, "department", dataDepartmentType);
    } else {
      requestResultModal(dataUrl, dataValue, "departmentAg", dataDepartmentType);
    }
  } else if (select.closest(".wrapper_research")) {
    selectionResearch();
  } else if (select.closest(".wrapper_lab")) {
    let researchValues = getResearchValue();
    dataUrl = select.closest(".wrapper_lab").getAttribute("data-url");
    requestCostOrder(researchValues, dataValue);
  } else if (select.closest(".js-landing-covid")) {
    requestChangeCity(dataValue);
  }
}
// END CUSTOM SELECT

// get cost order
function requestCostOrder(researchValues, labId) {
  const url = document.querySelector(".wrapper_lab").getAttribute("data-url");
  const request = new XMLHttpRequest();
  const params = "&research=" + researchValues + "&locality_id=" + document.querySelector(".js-landing-covid .selected").getAttribute("data-value") + "&lab_id=" + labId + "&_csrf=" + csrfToken;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4 && request.status === 200) {
      let response = JSON.parse(request.responseText);
      void 0;
      document.querySelector(".wrapper_research_cost").innerHTML = response.cost;
    }
  });
  request.send(params);
}

// REQUEST DEPARTMENT/HOME MODAL
function requestResultModal(url, id, type, typeDepartment) {
  const request = new XMLHttpRequest();
  let params;
  if (type === "department" || type === "departmentAg") {
    params = "&locality_id=" + id + "&research_type=" + typeDepartment + "&_csrf=" + csrfToken;
  } else {
    params = "&locality_id=" + id + "&_csrf=" + csrfToken;
  }
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4 && request.status === 200) {
      removeBlockCityInfo();
      let response = JSON.parse(request.responseText);
      if (type === "department") {
        removeModalResult(".department_for_plr .block_department_result");
        document.querySelector(".department_for_plr .block_department_result").innerHTML = response.html;
      }
      if (type === "departmentAg") {
        removeModalResult(".department_for_ag .block_department_result");
        document.querySelector(".department_for_ag .block_department_result").innerHTML = response.html;
      }
      if (type === "home") {
        removeModalResult(".block_home_result");
        document.querySelector(".block_home_result").innerHTML = response.html;
      }

      // Update button url with city
      let button = document.getElementById('js-add-to-cart-btn');
      if (button) {
        button.setAttribute('href', button.dataset.href + id);
      }
    }
  });
  request.send(params);
}

// remove select-city-popup-info from popup
function removeBlockCityInfo() {
  let blocksCityInfo = document.querySelectorAll(".select-city-popup-info");
  blocksCityInfo.forEach(block => {
    block.classList.remove("show");
  });
}

// remove result block from modal
function removeModalResult(resultClass) {
  let result = document.querySelector(resultClass);
  result.innerHTML = "";
}
// set start position select
function setNullSelect(wrapperClass) {
  let wrapperSelect = document.querySelector(wrapperClass);
  wrapperSelect.querySelector(".custom-select__trigger span").textContent = wrapperSelect.getAttribute("data-select-placeholder");
  wrapperSelect.querySelector(".custom-select__trigger span").setAttribute("data-value", "");
  removeSelectedOption(wrapperSelect);
}
function removeSelectedOption(select) {
  let selectedOptions = select.querySelectorAll(".selected");
  for (let option of selectedOptions) {
    option.classList.remove("selected");
  }
}
// END REQUEST DEPARTMENT/HOME MODAL

// CHANGE CITY
let modalChangeCity = document.getElementById("modal-change-city");
let closeModalChangeCity = document.querySelector(".close_modal_change_city");
closeModalChangeCity.onclick = function () {
  modalChangeCity.style.display = "none";
};
window.onclick = function (event) {
  if (event.target == modalChangeCity) {
    modalChangeCity.style.display = "none";
  }
};

// вызов модального окна выбора города по клику на .header_change_city-circle в шапке
let headerChangeCityBtn = document.querySelector(".header_change_city-circle");
headerChangeCityBtn.addEventListener("click", function (e) {
  modalChangeCity.style.display = "block";
});

// CHECK CITY
if (selectedCityCheck()) {
  setTimeout(() => modalChangeCity.style.display = "block", 2000);
  setCitySelect();
} else {
  setCitySelect();
}

// check city select in header
function selectedCityCheck() {
  const select = document.querySelector(".js-landing-covid");
  if (select.querySelector(".selected") == null) {
    return true;
  } else {
    return false;
  }
}

// set selected option in city selects
function setCitySelect() {
  let arrSelected = document.querySelectorAll(".js-landing-covid .selected");
  arrSelected.forEach(element => {
    element.closest(".custom-select").querySelector(".custom-select__trigger span").textContent = element.textContent;
    let dataValue = element.getAttribute("data-value");
    element.closest(".custom-select").querySelector(".custom-select__trigger span").setAttribute("data-value", dataValue);
  });
}

// REQUEST CHANGE CITY
function requestChangeCity(id) {
  const url = document.getElementsByName("change_city_url")[0].defaultValue;
  const request = new XMLHttpRequest();
  let params = `&landing-city=${id}&_csrf=${csrfToken}`;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4 && request.status === 200) {
      location.reload();
    }
  });
  request.send(params);
}

// UP BTN ON PAGE
const upBtn = document.querySelector('.up-btn');
if (upBtn) {
  window.onscroll = function () {
    if (window.pageYOffset > 280) {
      upBtn.classList.add('up-btn--show');
    } else {
      upBtn.classList.remove('up-btn--show');
    }
  };
  // плавный скролл наверх
  upBtn.addEventListener('click', function () {
    window.scrollBy({
      top: -document.documentElement.scrollHeight,
      behavior: 'smooth'
    });
  });
}